import { Box, BoxProps, Typography } from '@mui/material';

type LabeledContainerProps = {
    label: string;
    children: React.ReactNode;
    boxProps?: BoxProps;
};

export default function LabeledContainer({
    label,
    children,
    boxProps,
}: LabeledContainerProps) {
    return (
        <Box
            width="100%"
            p={1}
            pl={2}
            position="relative"
            sx={(theme) => ({
                borderRadius: `${theme.shape.borderRadius}px`,
                border: `1px solid ${theme.palette.divider}`,
            })}
            {...boxProps}
        >
            <Box position="relative" height="100%" width="100%">
                <Typography
                    variant="caption"
                    component="label"
                    color="text.secondary"
                    sx={(theme) => ({
                        position: 'absolute',
                        top: theme.spacing(-2.5),
                        left: theme.spacing(-0.5),
                        backgroundColor: 'background.default',
                        padding: `0 ${theme.spacing(0.5)}`,
                    })}
                >
                    {label}
                </Typography>

                <Box>{children}</Box>
            </Box>
        </Box>
    );
}
